import { render, staticRenderFns } from "./imgScreen.vue?vue&type=template&id=f6215982&scoped=true"
import script from "./imgScreen.vue?vue&type=script&lang=js"
export * from "./imgScreen.vue?vue&type=script&lang=js"
import style0 from "./imgScreen.vue?vue&type=style&index=0&id=f6215982&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6215982",
  null
  
)

export default component.exports